export function getAgeBandText(minAge: number | null, maxAge: number | null): string {
  if (minAge && maxAge) {
    if (minAge === maxAge) {
      return `age ${minAge}`;
    }
    return `ages ${minAge} - ${maxAge}`;
  } else if (minAge && !maxAge) {
    return `ages ${minAge}+`;
  } else if (!minAge && maxAge) {
    return `ages ${maxAge} and under`;
  }

  return "any age";
}
